import { createContext } from 'react'
import type { GridRowId } from '@mui/x-data-grid-pro'

import type { State, Dispatch } from './typings'

export const BulkActionContext = createContext<
  { state: State; dispatch: Dispatch; selectedRows: GridRowId[] } | undefined
>(undefined)
